function AppBar_HicretKuruyemis_2() {
  return (
    <>
      <img src={'https://d9aff4nz0lkg0.cloudfront.net/appBar_0.png'} className={` w-full `} />
    </>
  );
}

export default AppBar_HicretKuruyemis_2;
